<template>
  <div v-if="visible">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div>
            <button type="button" @click="close">Close</button>
          </div>
          <div class="modal-body loader-container">
            <Loader :loading="loadingIframe" />
            <iframe
              v-show="!loadingIframe"
              :src="url"
              :description="description"
              @load="iframeloaded"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Loader from '@/components/Loader.vue';
export default {
  components: { Loader },
  props: {
    visible: { type: Boolean, default: false },
    url: { type: String, default: null },
    description: { type: String, default: null }
  },
  data: function() {
    return {
      loadingIframe: true
    };
  },
  methods: {
    iframeloaded() {
      this.loadingIframe = false;
    },
    close() {
      this.$emit('close');
      this.loadingIframe = true;
    }
  }
};
</script>
